import type { CampaignViewMode } from './campaign-list-view';

/**
 * The campaign list has two densities: rich 'cards' and a compact 'rows' grid.
 * The 'rows' grid is a fixed ~482px column layout that overflows a phone, so
 * mobile always renders 'cards' regardless of the stored preference (which is
 * kept intact for when the user is back on desktop). Pure so the contract is
 * unit-testable.
 */
export function effectiveCampaignView(isMobile: boolean, stored: CampaignViewMode): CampaignViewMode {
  return isMobile ? 'cards' : stored;
}
